<script setup>
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { INBOX_HIERARCHY_CONTEXT } from 'dashboard/composables/useInboxHierarchy';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const props = defineProps({
  emptyStateMessage: { type: String, default: '' },
});
const { t } = useI18n();
const uiFlags = useMapGetter('notifications/getUIFlags');
const hierarchyActive = inject(INBOX_HIERARCHY_CONTEXT, ref(false));
const emptyMessage = computed(() => {
  if (props.emptyStateMessage) return props.emptyStateMessage;
  return t(hierarchyActive.value ? 'INBOX_HIERARCHY.NOTE' : 'INBOX.LIST.NOTE');
});
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full text-center bg-n-surface-1 lg:flex"
  >
    <div
      v-if="uiFlags.isFetching && !hierarchyActive"
      class="flex justify-center my-4"
    >
      <Spinner class="text-n-brand-text" />
    </div>
    <div v-else class="flex flex-col items-center gap-2">
      <Icon
        v-if="hierarchyActive"
        icon="i-lucide-list-tree"
        class="size-10 text-n-slate-11"
      />
      <fluent-icon v-else icon="mail-inbox" size="40" class="text-n-slate-11" />
      <span class="text-sm font-medium text-n-slate-11">
        {{ emptyMessage }}
      </span>
    </div>
  </div>
</template>
